import QuillReal from "quill";
import { Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import ReactQuill, { Quill, ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";

const quillModulesDefault = {
	toolbar: [
		[{ header: [false] }],
		["bold", "italic", "underline"],
		["link"],
		[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
		["clean"],
	],
};

interface QuillCounterOptions {
	setCount?: (value: number) => void;
}

Quill.register("modules/counter", function (quill: any, options: QuillCounterOptions) {
	quill.on("text-change", function () {
		var text = quill.getText();
		options?.setCount?.(text.length - 1);
	});
});

interface Props extends ReactQuillProps {
	showCounter?: boolean;
	maxLength?: number;
	onLength?: (length: number) => void;
}
const { Text } = Typography;
const TextEditor: React.FC<Props> = ({ showCounter, maxLength, onLength, ...rest }) => {
	const [count, setCount] = useState(0);
	const quillRef = useRef<QuillReal | null>(null);
	const reactQuillRef = useRef<ReactQuill | null>(null);

	useEffect(() => {
		if (reactQuillRef.current) {
			if (typeof reactQuillRef.current.getEditor !== "function") return;
			quillRef.current = reactQuillRef.current.getEditor();
		}
	}, [reactQuillRef]);

	useEffect(() => {
		if (quillRef.current && maxLength !== undefined) {
			quillRef.current.on("text-change", () => {
				if (quillRef.current && maxLength !== undefined && quillRef.current.getLength() > maxLength) {
					quillRef.current.deleteText(maxLength, quillRef.current.getLength());
				}
			});
		}
	}, [quillRef, maxLength]);

	useEffect(() => {
		onLength?.(count ?? 0);
	}, [count]);

	return (
		<div>
			<ReactQuill
				ref={(e) => (reactQuillRef.current = e)}
				modules={{
					counter: showCounter
						? {
								setCount,
						  }
						: false,
					toolbar: quillModulesDefault.toolbar,
				}}
				{...rest}
			/>
			<div className="ql-counter">
				{showCounter ? (
					<Text type="secondary">
						{count}
						{maxLength !== undefined ? "/" + maxLength : ""}
					</Text>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};
export default TextEditor;
